/**
 * appConfig · Sprint 6A · Default Landing Page.
 *
 * Single configuration point for post-login navigation. Future work
 * (per-user preference, role-based homes) reads from this module so
 * the routing tree never needs a follow-up refactor.
 *
 *   - DEFAULT_HOME_ROUTE : the fallback when no per-user preference exists.
 *   - getHomeRoute()     : the resolver hook — currently returns the
 *                          constant; will consult user preferences later.
 */
export const DEFAULT_HOME_ROUTE = "/todays-orders";

/**
 * Resolves the effective home route for a given user. For now this
 * always returns the platform default; when user-preference storage
 * lands, this function reads it from the user record without any
 * change to callers.
 */
export function getHomeRoute(/* user */) {
  return DEFAULT_HOME_ROUTE;
}
